import { IGroupedPermissions, ILCHttpResponse, IPermissionsVisibility } from '@logicalcommander/types'
import { createApi } from '@reduxjs/toolkit/query/react'
import { v4 as uuidv4 } from 'uuid'
import { configManager } from '../../config/configManager'
import { ISettingUpdatePermissions } from '../pages/Settings/components/permissions/permissions-helper'
import { RootState } from '../redux/store'
import { createBaseQueryWithErrorHandling } from './baseQueryWithErrorHandling'

export const permissionsApi = createApi({
  reducerPath: 'permissionsApi',
  baseQuery: createBaseQueryWithErrorHandling(`${configManager.api.GATEWAY_URL}/permissions`, (headers, { getState }) => {
    headers.set('x-request-id', uuidv4())
    const { token, companyToken } = (getState() as RootState).authReducer
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    if (companyToken) {
      headers.set('x-company-token', companyToken)
    }
    return headers
  }),
  endpoints: (builder) => ({
    getAllPermissionsGrouped: builder.mutation<IGroupedPermissions[], void>({
      query: () => {
        return {
          url: 'grouped',
          method: 'GET',
        }
      },
      transformResponse: (rawResult: ILCHttpResponse<IGroupedPermissions[]>, meta) => {
        return rawResult.data as IGroupedPermissions[]
      },
    }),
    getPermissionsVisibility: builder.mutation<IPermissionsVisibility, void>({
      query: () => {
        return {
          url: 'visibility',
          method: 'GET',
        }
      },
      transformResponse: (rawResult: ILCHttpResponse<IPermissionsVisibility>, meta) => {
        return rawResult.data as IPermissionsVisibility
      },
    }),
    updatePermissions: builder.mutation<ISettingUpdatePermissions, Partial<ISettingUpdatePermissions>>({
      query: (body) => ({
        url: '/permissions',
        method: 'PUT',
        body,
      }),
      transformResponse: (rawResult: ILCHttpResponse<ISettingUpdatePermissions>, meta) => {
        return rawResult.data as ISettingUpdatePermissions
      },
    }),
  }),
})

export const { useGetAllPermissionsGroupedMutation, useGetPermissionsVisibilityMutation, useUpdatePermissionsMutation } = permissionsApi
